import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CriSection from "../../components/CriSection";
import CompletedTile from "./CompletedTile";
import CompletedResearch from "../../constants/completed_research";
import { useState } from "react";
import PdfDialog from "../../components/PdfDialog";
import { useNavigate } from "react-router-dom";

const CompletedSection = () => {
  const navigate = useNavigate();
  const [showPdfDialog, setShowPdfDialog] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfTitle, setPdfTitle] = useState("");

  const onShowResearchPaper = ({
    title,
    pdf,
  }: {
    title: string;
    pdf: string;
  }) => {
    setShowPdfDialog(true);
    setPdfTitle(title);
    setPdfUrl(pdf);
  };

  return (
    <CriSection alternate={true}>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 300,
        }}
      >
        Completed Research Projects
      </Typography>

      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 300,
          lineHeight: 1.2,
          marginTop: "12px",
          marginBottom: "36px",
        }}
      >
        Conservation Research Institute is producing a series of guides to
        Chicago region vascular plant genera with illustrations by Kathleen
        Marie Garness.
      </Typography>

      <Grid container spacing={{ xs: 1, md: 4 }} alignItems="stretch">
        {CompletedResearch.map((research, index) => (
          <Grid key={index} size={{ xs: 6, md: 4 }}>
            <CompletedTile
              title={research.title}
              description={research.description}
              image={research.image}
              link={research.link}
              onButtonClick={() => {
                if (research.pdf) {
                  onShowResearchPaper({
                    title: research.title,
                    pdf: research.pdf!,
                  });
                } else {
                  navigate(research.link!);
                }
              }}
            />
          </Grid>
        ))}
      </Grid>
      <PdfDialog
        open={showPdfDialog}
        onClose={() => setShowPdfDialog(false)}
        title={pdfTitle}
        pdfUrl={pdfUrl}
      />
    </CriSection>
  );
};

export default CompletedSection;
